import { render, staticRenderFns } from "./ReviewListPage.vue?vue&type=template&id=5af0f42c&scoped=true&"
import script from "./ReviewListPage.vue?vue&type=script&lang=js&"
export * from "./ReviewListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af0f42c",
  null
  
)

export default component.exports